// extracted by mini-css-extract-plugin
export default {"layout":"layout__a6841b10"};